import { QueryKey } from '@/config/query-client';
import { useQuery } from '@tanstack/react-query';
import { projectIdState } from '../project.state';
import { getTimeInMs } from '@/helpers/get-time-in-ms';
import { fetchProjectListingsCount } from '@/api/v4/project-listings.api';
import { useListingsSearchParam } from './use-listings-search-param';
import { useAtomValue } from 'jotai';

export const useProjectListingsCount = () => {
  const projectId = useAtomValue(projectIdState);
  const { listingsSearchParam } = useListingsSearchParam();

  return useQuery({
    queryKey: [
      QueryKey.ProjectListingsCount,
      projectId,
      listingsSearchParam ? [listingsSearchParam] : [],
    ],
    queryFn: () =>
      projectId
        ? fetchProjectListingsCount(
            projectId,
            listingsSearchParam ? { search: listingsSearchParam } : undefined,
          )
        : undefined,
    staleTime: getTimeInMs(5, 'minute'),
    enabled: !!projectId,
  });
};
